import { defineComponent as _defineComponent } from 'vue'
import { provide, ref } from 'vue';

interface Props {
  open?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiDisclosure',
  props: {
    open: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { open: boolean };



const isOpen = ref(props.open);
const toggle = () => {
  isOpen.value = !isOpen.value;
};

provide('isOpen', isOpen);
provide('toggle', toggle);

return { __sfc: true,props, isOpen, toggle }
}

})